<style lang="scss" scoped>
    @import "../../../common/styles/var";

    .fullpage {
        background-color: #f0f0f0;
        background-image: url("../assets/daping-bg.png");
        background-position: right bottom;
        background-repeat: repeat;
        background-size: 100% 100%;
    }

    header {
        background-color: rgba(255, 255, 255, 0.08);
        height: 60px;
    }

    ol {
        height: 50px;
    }

    .line {
        width: 1px;
        height: 20px;
        background-color: white;
    }

    .router-link-active {
        color: $mainColor;
    }
</style>
<template>
    <div class="fullpage oh flex column">
        <header class="flex pl35 pr35 aic flex0">
            <span class="flex1 color_fff fs32">浙二互联网医院急救监控大屏</span>
            <daping-timer class="color_fff fs14"></daping-timer>
        </header>
        <div class="pl35 pr35 flex1 flex oh column">
            <ol class="color_fff fs26 flex aic flex0">
                <router-link to="/staff/daping/total" tag="li" class="pointer">总体监控</router-link>
                <li class="line ml10 mr10"></li>
                <router-link to="/staff/daping/today" tag="li" class="pointer">今日数据</router-link>
            </ol>
            <router-view class="flex1 oh color_fff"></router-view>
        </div>
    </div>
</template>
<script>
  import DapingTimer from "../components/daping/timer";

  export default {
    name: 'jijiu-daping',
    components: {DapingTimer}
  }
</script>
